import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getAssociatedDomainOptions = get('guest.associatedDomainOptions');

export const getAll = createSelector(getAssociatedDomainOptions, get('all'));

export const getMeta = createSelector(getAssociatedDomainOptions, get('meta'));

export const getFetching = createSelector(
  getAssociatedDomainOptions,
  get('fetching')
);

export const getFetched = createSelector(
  getAssociatedDomainOptions,
  get('fetched')
);
